import { useEffect } from 'react';
import { useStore } from '../lib/store';

export function Toast(): JSX.Element | null {
  const toast = useStore((s) => s.toast);
  const dismiss = useStore((s) => s.dismissToast);

  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => dismiss(), toast.ttlMs);
    return () => clearTimeout(t);
  }, [toast, dismiss]);

  if (!toast) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-20 z-[2000] flex justify-center px-4">
      <div className="pointer-events-auto flex items-center gap-4 rounded-full border border-white/10 bg-bg-elev px-4 py-2 text-sm text-text shadow-lg">
        <span>{toast.text}</span>
      </div>
    </div>
  );
}
